// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__L6FKO","rotation":"style_rotation__z+kcz"};